import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IndexAndViewer from '../shared/IndexAndViewer';
import AccountPlatformsContainer from './AccountPlatformsContainer';

export default class AccountPlatformsPage extends Component {
  static propTypes = {
    accounts: PropTypes.object.isRequired,
    activeLink: PropTypes.number,
    handleAccountSelect: PropTypes.func.isRequired,
    selectedAccount: PropTypes.object,
  };

  static defaultProps = {
    activeLink: null,
    selectedAccount: undefined,
  };

  renderAccountOrdersIndexContainer = () => {
    const { selectedAccount } = this.props;
    return selectedAccount && selectedAccount.id !== 0 ? (
      <AccountPlatformsContainer account={selectedAccount} />
    ) : (
      <div className="no-reports text-muted">
        <p>Please select an account to view platforms</p>
      </div>
    );
  };

  render() {
    const { activeLink, accounts, handleAccountSelect } = this.props;

    return (
      <div className="container extra-wide-table">
        <div className="row row-top">
          <div className="col-xs-12">
            <h1>Platforms</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            {accounts.size === 0 ? (
              <div className="no-reports text-muted">
                <p>There are no accounts created</p>
              </div>
            ) : (
              <IndexAndViewer
                activeLink={activeLink}
                content={this.renderAccountOrdersIndexContainer()}
                handleSelect={handleAccountSelect}
                list={accounts}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
